var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Mongolia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c62828",
    d: "M4,24c0,8.955,5.886,16.533,14,19.082V4.918C9.886,7.467,4,15.045,4,24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#c62828",
    d: "M30,4.918v38.163C38.114,40.533,44,32.955,44,24C44,15.045,38.114,7.467,30,4.918z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#01579b",
    d: "M24,4c-2.091,0-4.106,0.323-6,0.918v38.163C19.894,43.677,21.909,44,24,44s4.106-0.323,6-0.918 V4.918C28.106,4.323,26.091,4,24,4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd600",
    d: "M12,19c-1.34,0-2.492-0.898-3-2.055C9,16.965,9,16.98,9,17c0,1.656,1.344,3,3,3s3-1.344,3-3 c0-0.02,0-0.035,0-0.055C14.492,18.102,13.34,19,12,19z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd600",
    d: "M14,16c0,1.105-0.895,2-2,2s-2-0.895-2-2s0.895-2,2-2S14,14.895,14,16z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd600",
    d: "M11,12.063C11,12.578,11.449,13,12,13s1-0.422,1-0.938c0-0.375-0.25-0.422-0.25-0.563 s0.148-0.328-0.148-0.563c0.148,0.234-0.102,0.281-0.102,0.516s0.102,0.234,0.102,0.422c0,0.102-0.09,0.188-0.203,0.188 c-0.109,0-0.199-0.086-0.199-0.188c0-0.188,0.199-0.375,0.199-0.656s-0.047-0.375-0.199-0.609C12.051,10.375,11.801,10.188,12,10 c-0.301,0.094-0.148,0.469-0.148,0.703s-0.203,0.375-0.203,0.656s0.152,0.328,0.152,0.516c0,0.105-0.09,0.188-0.199,0.188 c-0.113,0-0.203-0.082-0.203-0.188c0-0.188,0.102-0.188,0.102-0.422s-0.25-0.281-0.102-0.516c-0.297,0.234-0.148,0.422-0.148,0.563 S11,11.688,11,12.063z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd600",
    d: "M7,21h2v12H7V21z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd600",
    d: "M15,21h2v12h-2V21z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd600",
    d: "M10,30.023h4v1h-4V30.023z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd600",
    d: "M10,23h4v1h-4V23z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd600",
    d: "M10,32.023h4l-2,1L10,32.023z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd600",
    d: "M10,21h4l-2,1L10,21z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd600",
    d: "M12,25.023c-1.102,0-2,0.898-2,2c0,0.758,0.426,1.422,1.051,1.758 c-0.145-0.195-0.23-0.438-0.23-0.699c0-0.648,0.527-1.18,1.18-1.18c0.52,0,0.941-0.422,0.941-0.938 C12.941,25.445,12.52,25.023,12,25.023z M12,26.363c-0.223,0-0.398-0.18-0.398-0.398c0-0.223,0.176-0.402,0.398-0.402 s0.398,0.18,0.398,0.402C12.398,26.184,12.223,26.363,12,26.363z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd600",
    d: "M12.949,25.262c0.145,0.199,0.23,0.438,0.23,0.703c0,0.648-0.527,1.18-1.18,1.18 c-0.52,0-0.941,0.422-0.941,0.938c0,0.52,0.422,0.941,0.941,0.941c1.102,0,2-0.898,2-2C14,26.262,13.574,25.602,12.949,25.262z M12,28.504c-0.223,0-0.398-0.18-0.398-0.398c0-0.223,0.176-0.402,0.398-0.402s0.398,0.18,0.398,0.402 C12.398,28.324,12.223,28.504,12,28.504z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Mongolia);
export default __webpack_public_path__ + "static/media/icons8-mongolia.b6cd8ef55eca282fe0f62c44a6e90f39.svg";
export { ForwardRef as ReactComponent };